import { call, put } from 'redux-saga/effects';
import { setUserDetails } from '../account/accountSlice';
import {
  requestSavePersonalDetails,
} from './personalDetailsFormRequests';
import {
  setPersonalDetailsFormError,
  setPersonalDetailsFormStatus,
  setSavedPersonalDetails,
} from './personalDetailsFormSlice';

export function* handleSavePersonalDetails(action:any): Generator<any, any, any> {
  yield put(setPersonalDetailsFormStatus('loading'));
  try {
    const response = yield call(
      requestSavePersonalDetails,
      action.payload
    );
    const { data } = response;
    if (data.message) {
      yield put(setSavedPersonalDetails(action.payload));
      yield put(setUserDetails(data.user));
    }
  } catch (error: any) {
    yield put(setPersonalDetailsFormError({
      isError: true,
      type: 'save_personal_details',
      message: error?.response?.data?.message,
    }));
  }
}

export default {};
